/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { Tab } from '../../../core/model/tab.model';
import { TerminalStatus } from '../../../core/model/terminal-status.model';
import { TrainData } from '../../../core/model/train-data.model';
import { AppUtilityService } from '../../../core/services/app-utility.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsLoggerService } from '../../../core/services/lms-logger.service';
import { UserService } from '../../../core/services/user.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { ConfigService } from './../../../core/services/config.service';
import { LmsTabsDragDropService } from './../../../core/services/lms-tabs-drag-drop.service';
import { StaticDataStoreService } from './../../../core/services/static-datastore.service';



;
/**
 * @export
 * @class LmsTerminalBoundComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-terminal-bound',
  templateUrl: './lms-terminal-bound.component.html',
  styleUrls: ['./lms-terminal-bound.component.scss']
})
export class LmsTerminalBoundComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  imagesPath;
  heightArray: Array<string>;
  startPage: Number;
  endPage: Number;
  showTooltip: boolean = false;
  @Input() collpase: Boolean;
  @Input() direction: string;
  @Input() tab: Tab;
  @Input() header: string;
  @Input() allData: TerminalStatus;
  @Input() boundTrains: Array<TrainData>;
  @Input() inOutBoundHeight: number;
  @Output() showLocoMenu: EventEmitter<Map<string, any>> = new EventEmitter<Map<string, any>>();
  @Output() showTrainMenu: EventEmitter<Map<string, any>> = new EventEmitter<Map<string, any>>();
  @Output() hideContextMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() heightCalculate: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() toggleBound = new EventEmitter();
  viewPortHeight: number;
  viewPortWidth: number;
  endIndex = 0;
  loading: boolean;
  boundTrainsPartial: Array<TrainData> = [];
  private pendingListData;
  div: any;
  @ViewChild('viewPortPaging') viewPageDirective;
  private selectedTrainLocos: Object = {
    trains: { list: [], identifier: [] },
    locos: { list: [], identifier: [] }
  };
  constructor(private configService: ConfigService,
    private staticDataStoreService: StaticDataStoreService,
    private eRef: ElementRef, private lmsTabsDragDropService: LmsTabsDragDropService, private changeDetectorRef: ChangeDetectorRef,
    private lmsLoaderService: LmsLoaderService,
    private appUtilityService: AppUtilityService, private lmsLoggerService: LmsLoggerService,
    public user: UserService) {
    this.imagesPath = this.configService.getConfigData().images;
    this.heightArray = [];
    this.appUtilityService.screenResize$.subscribe((data) => {
      setTimeout(() => {
        this.getNumberofVisible();
      }, 500);
    });
  }

  ngOnInit() {
    this.heightArray.push(this.eRef.nativeElement.offsetHeight);

  }
  /**
   * this method is execute to set no of visible
   * item after 100 miliseconds
   * @memberof LmsTerminalBoundComponent
   */
  visible() {
    setTimeout(() => {
      this.getNumberofVisible();
    }, 100);
  }

  /**
   * this is ng life cycle execute after tempate load
   * at that time we set partial data to show in bound list
   * inbound and outbound
   * @memberof LmsTerminalBoundComponent
   */
  ngAfterViewInit() {
    this.div = document.getElementById('trainDragContent' + this.header);
    this.setPartialData();
    this.fillPartialData(this.endIndex);
    this.endIndex++;

    setTimeout(() => {
      this.updateScreenSize();
    }, 100);
  }

  /**
  * this is ng life cycle execute when any changes come from input
  * at that time we set partial data to show in bound list
  * inbound and outbound
   * @memberof LmsTerminalBoundComponent
   */
  ngOnChanges() {
    setTimeout(() => {
      this.setPartialData();
      this.fillPartialData(this.endIndex);
      setTimeout(() => {
        this.updateScreenSize();
      }, 300);
    }, 200);

  }

  /**
   * to update screen size
   * @memberof LmsTerminalBoundComponent
   */
  updateScreenSize() {
    this.viewPageDirective.updateScreenSizeSetting();

  }

  ngOnDestroy() {
  }

  /**
   * do some setting on train click
   * like set click property true or vice versa
   * @param {TrainData} train
   * @param {any} event
   * @param {number} index
   * @returns
   * @memberof LmsTerminalBoundComponent
   */
  onTrainClick(train: TrainData, event, index: number) {
    event.stopPropagation();
    this.hideLocoTrainContextPanel();
    if (train.inPendingList) {
      return false;
    }
    const resetAllClickOnTrainLocosCounter = this.resetAllClickOnTrainLocos(false, false, false, false);
    if (resetAllClickOnTrainLocosCounter.locoCounter) {
      let sortLocoData = _.sortBy(train.locoDetails, ['order']);

      /**reset all train state like click and etc */
      this.resetAllClickOnTrainLocos(true, false, false, false);

      sortLocoData = _.filter(sortLocoData, function (data) {
        return !_.isUndefined(data.order) && data.clicked && !data.inPendingList;
      });

      if (sortLocoData.length > 1) {// resequnce case
        this.lmsTabsDragDropService.updateDropEndValue('end', {

          dragElement: {
            type: this.header,
            train: {
              index: index,
              identifier: train.trainIdentifier,
              data: train
            },
            loco: {
              index: sortLocoData[sortLocoData.length - 2].loadOrder,
              identifier: sortLocoData[sortLocoData.length - 2].locomotiveIdentifier,
              data: sortLocoData[sortLocoData.length - 2]
            }
          },
          dropElement: {
            type: this.header,
            train: {
              index: index,
              identifier: train.trainIdentifier,
              data: train
            },
            loco:
            {
              index: sortLocoData[sortLocoData.length - 1].loadOrder,
              identifier: sortLocoData[sortLocoData.length - 1].locomotiveIdentifier,
              data: sortLocoData[sortLocoData.length - 1]
            }
          },
          trainLocos: {
            locos: { list: [] },
            trains: { list: [] }
          },
          requenceCanHappen: true
        });
      } else if (sortLocoData.length === 1) {
        // plan to terminal case
        this.lmsTabsDragDropService.updateDropEndValue('end', {
          dragElement: {
            type: this.header,
            train: {
              index: index,
              identifier: train.trainIdentifier,
              data: train
            },
            loco: {
              index: sortLocoData[sortLocoData.length - 1].loadOrder,
              identifier: sortLocoData[sortLocoData.length - 1].locomotiveIdentifier,
              data: sortLocoData[sortLocoData.length - 1]
            }
          },
          dropElement: {
            type: this.header,
            train: {
              index: index,
              identifier: train.trainIdentifier,
              data: train
            },
            loco: {
              index: train.locoDetails[0].loadOrder,
              identifier: train.locoDetails[0].locomotiveIdentifier,
              data: train.locoDetails[0]
            }
          },
          trainLocos: {
            locos: { list: [] },
            trains: { list: [] }
          },
          requenceCanHappen: true

        });
      } else {
        // plan to terminal case
        this.lmsTabsDragDropService.updateDropEndValue('end', {
          dragElement: {
            type: 'INBOUND',
            train: null,
            loco: 'last'
          },
          dropElement: {
            type: this.header,
            train: {
              index: index,
              identifier: train.trainIdentifier,
              data: train
            },
            loco: 'last'
          },
          trainLocos: undefined
          // requenceCanHappen: true
        });
      }
    } else {

      train.clicked = !train.clicked;
      if (train.clicked) {
        train.order = ++this.resetAllClickOnTrainLocos(false, false, true, false).trainCounter;
      } else {
        train.order = 0;
      }
      this.lmsTabsDragDropService.updateInteractiveLocoTrains();
    }
  }
  /**
   * do some setting on loco click action like
   *  clicked property set true or vice versa
   * @param {LocoDetail} loco
   * @param {any} event
   * @returns
   * @memberof LmsTerminalBoundComponent
   */
  onLocoClick(loco: LocoDetail, event) {
    event.stopPropagation();
    this.hideLocoTrainContextPanel();
    if (loco.inPendingList || loco.locomotiveIdentifier.toLowerCase() === 'zzzzzzzzzzzzzz') {
      return false;
    }

    loco.clicked = !loco.clicked;
    if (loco.clicked) {
      if (this.resetAllClickOnTrainLocos(false, false, false, false).trainCounter === 1) {
        loco.order = ++this.resetAllClickOnTrainLocos(false, false, false, false).locoCounter;
      } else {
        loco.order = ++this.resetAllClickOnTrainLocos(true, false, false, false).locoCounter;
      }
    } else {
      loco.order = 0;
    }


    this.lmsTabsDragDropService.updateInteractiveLocoTrains(loco, loco.clicked ? true : false);
  }

  /**
   * reset train or loco status
   *  as per pass parameter
   * @private
   * @param {Boolean} setTrainStatus
   * @param {Boolean} trainStatus
   * @param {Boolean} setLocoStatus
   * @param {Boolean} locoStatus
   * @returns
   * @memberof LmsTerminalBoundComponent
   */
  private resetAllClickOnTrainLocos(setTrainStatus: Boolean, trainStatus: Boolean, setLocoStatus: Boolean, locoStatus: Boolean) {
    const inBoundTrains = this.allData.terminalStatusIO.inBoundTrains;
    const outBoundTrains = this.allData.terminalStatusIO.outBoundTrains;
    const terminalList = this.allData.terminalStatusLocos;
    const totalTerminalListLocos = [terminalList.onTerminalList,
    terminalList.atServiceCentreList,
    terminalList.onPitList,
    terminalList.inShopList,
    terminalList.inReadyTrackList,
    terminalList.storedAtTerminalList,
    terminalList.yardAndLocalList
    ];



    const inBoundTrainsLength = inBoundTrains.length;
    const outBoundTrainsLength = outBoundTrains.length;
    let trainCounter = 0;
    let locoCounter = 0;
    // for inBoundTrains
    for (let i = 0; i < inBoundTrainsLength; i++) {
      if (setTrainStatus) {
        this.setTrainClickedStatus(inBoundTrains[i], trainStatus, locoStatus);
      } else {
        const inBoundMaxOrder = this.getTrainCounter(inBoundTrains[i]);
        trainCounter = inBoundMaxOrder > trainCounter ? inBoundMaxOrder : trainCounter;
      }

      const locos = inBoundTrains[i].locoDetails;
      if (setLocoStatus) {
        this.setTrainLocosClickedStatus(locos, locoStatus);
      } else {
        const inLocoMaxOrder = this.getLocoCounter(locos);
        locoCounter = inLocoMaxOrder > locoCounter ? inLocoMaxOrder : locoCounter;
      }

    }

    // for outboundTrains
    for (let i = 0; i < outBoundTrainsLength; i++) {
      if (setTrainStatus) {
        this.setTrainClickedStatus(outBoundTrains[i], trainStatus, locoStatus);
      } else {
        const outBoundMaxOrder = this.getTrainCounter(outBoundTrains[i]);
        trainCounter = outBoundMaxOrder > trainCounter ? outBoundMaxOrder : trainCounter;
      }

      const locos = outBoundTrains[i].locoDetails;
      if (setLocoStatus) {
        this.setTrainLocosClickedStatus(locos, locoStatus);
      } else {
        const outLocoMaxOrder = this.getLocoCounter(locos);
        locoCounter = outLocoMaxOrder > locoCounter ? outLocoMaxOrder : locoCounter;
      }
    }

    if (setLocoStatus) {
      // in terminal List only Locos Exist
      for (let k = 0; k < totalTerminalListLocos.length; k++) {
        if (!_.isEmpty(totalTerminalListLocos[k])) {
          this.setTrainLocosClickedStatus(totalTerminalListLocos[k], locoStatus);
        }
      }

    } else {
      for (let k = 0; k < totalTerminalListLocos.length; k++) {
        if (!_.isEmpty(totalTerminalListLocos[k])) {
          const terminalListMaxOrder = this.getLocoCounter(totalTerminalListLocos[k]);
          locoCounter = terminalListMaxOrder > locoCounter ? terminalListMaxOrder : locoCounter;
        }
      }
    }

    return { trainCounter: trainCounter, locoCounter: locoCounter };
  }
  /**
   * set train click status as per pass paramtere
   * @private
   * @param {TrainData} train
   * @param {Boolean} trainStatus
   * @param {Boolean} locoStatus
   * @memberof LmsTerminalBoundComponent
   */
  private setTrainClickedStatus(train: TrainData, trainStatus: Boolean, locoStatus: Boolean) {
    train.order = 0;
    train.clicked = trainStatus;
  }

  /**
   * set train respective loco click status
   * @private
   * @param {Array<LocoDetail>} locos
   * @param {Boolean} status
   * @memberof LmsTerminalBoundComponent
   */
  private setTrainLocosClickedStatus(locos: Array<LocoDetail>, status: Boolean) {
    const locosLength = locos.length;
    for (let k = 0; k < locosLength; k++) {
      locos[k].clicked = status;
      locos[k].order = 0;
    }
  }

  /**
   * @private
   * @param {Array<LocoDetail>} locos
   * @returns
   *
   * @memberOf LmsTerminalBoundComponent
   */
  private getLocoCounter(locos: Array<LocoDetail>) {
    const locosLength = locos.length;
    let locoCount = 0;
    for (let k = 0; k < locosLength; k++) {
      if (!locos[k].inPendingList) {
        locoCount = locos[k].order > locoCount ? locos[k].order : locoCount;
      }

    }
    return locoCount;
  }

  /**
   * @private
   * @param {TrainData} train
   * @returns
   *
   * @memberOf LmsTerminalBoundComponent
   */
  private getTrainCounter(train: TrainData) {
    return !train.inPendingList ? train.order : 0;
  }

  /**
   * This shows Train Context Menu
   * @param {TrainData} train
   * @memberOf LmsTerminalBoundComponent
   */
  public showTrainContextMenu(train: TrainData, index: string) {
    const trainMenu = new Map<string, any>();
    if (train && train.trainIdentifier && train.trainIdentifier.length > 4) {
      trainMenu.set('trainData', train);
      trainMenu.set('trainId', 'train' + index + this.header + train.trainIdentifier);
      this.showTrainMenu.emit(trainMenu);
    }
  }

  /**
   * This shows Locomotive Context Menu
   * @param {TrainData} train
   * @param {LocoDetail} loco
   * @memberOf LmsTerminalBoundComponent
   */
  public showLocomotiveContextMenu(train: TrainData, loco: LocoDetail, index: string) {
    if (this.isContextMenuAvailable(loco)) {
      this.hideLocoTooltip(loco);
      const locoMenu = new Map<string, any>();
      if (train && loco && train.trainIdentifier && train.trainIdentifier.length > 5
        && loco.locomotiveIdentifier && loco.locomotiveIdentifier.length > 5) {
        locoMenu.set('locoData', loco);
        locoMenu.set('trainId', 'train' + train.trainIdentifier);
        locoMenu.set('index', index);
        locoMenu.set('header', this.header);
        this.showLocoMenu.emit(locoMenu);
      }
    }
  }

  getDescription(loco : LocoDetail) {
    if (loco && loco.listOfFeature && loco.listOfFeature.length > 0) {
      if(loco.listOfFeature.findIndex((feature) => {
        return feature.featureDescription === 'R1547' || feature.featureDescription === 'DISTRIBUTED POWER LXA WITH ITCM COMMS';
      }) > -1) {
        return "DP-LXA ITC";
      } else if(loco.listOfFeature.findIndex(feature => {
        return feature.featureDescription === 'R1543' || feature.featureDescription === 'DISTRIBUTED POWER LXA LOCOMOTIVE';
      }) > -1) {
        return "DP-LXA";
      } else if(loco.listOfFeature.findIndex(feature => {
        return feature.featureDescription === 'R1532' || feature.featureDescription === 'DISTRIBUTED POWER';
      }) > -1) {
        return "DP";
      } else {
        return '';
      }
    }
    return '';
  }

  formatDateOnly(dateStr: string): string {
   if (!dateStr) return '';
    const datePart = dateStr.split(' ')[0];
    if (datePart.indexOf('-') > -1) {
      return datePart.replace(/-/g, '/');
    }
    return datePart;
  }

    /**
   * Format the locomotive id
   * @private
   * @param {string} value
   * @returns {string}
   * @memberOf LmsLocoContextMenuComponent
   */
  formatLocomotiveId(value: string): string {
    if (value) {
      value = value.trim();
      const v = value.match(/\d+/);
      if (v) {
        const locoInitial = (v.index <= 4) ? value.substring(0, v.index).trim() : value.substring(0, 4).trim();
        const locoNumber = (v.index <= 4) ? value.substring(v.index, value.length).trim() : value.substring(4, value.length).trim();
        return locoInitial + ' ' + locoNumber.replace(/^0+/, '');
      }
    }
  }

  private tooltipTimers = new WeakMap<any, any>();

startLocoTooltip(locoDetails: any) {
  this.hideLocoTooltip(locoDetails);
  const timer = setTimeout(() => {
    locoDetails.showTooltip = true;
  }, 1000);

  this.tooltipTimers.set(locoDetails, timer);
}

hideLocoTooltip(locoDetails: any) {
  const timer = this.tooltipTimers.get(locoDetails);
  if (timer) {
    clearTimeout(timer);
    this.tooltipTimers.delete(locoDetails);
  }
  locoDetails.showTooltip = false;
}

  /**
   * check if loco in pending list or not
   * @param {Array<LocoDetail>} locoList
   * @returns
   * @memberof LmsTerminalBoundComponent
   */
  isLocosInPendingList(locoList: Array<LocoDetail>) {
    if (!locoList) {
      return false;
    }
    const locoListLength = locoList.length;
    for (let i = 0; i < locoListLength; i++) {
      if (locoList[i].inPendingList === true) {
        return true;
      }
    }
    return false;
  }

  /**
   * @private
   * @param {LocoDetail} locomotive
   * @returns
   *
   * @memberOf LmsTerminalBoundComponent
   */
  private isContextMenuAvailable(locomotive: LocoDetail) {
    if (locomotive && locomotive.locomotiveIdentifier) {
      if (locomotive.locomotiveIdentifier.toUpperCase() === 'ZZZZZZZZZZZZZZ') {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  /**
   * This method is used to close the context panel
   * of train or locomotive
   * @memberOf LmsTerminalBoundComponent
   */
  public hideLocoTrainContextPanel() {
    this.hideContextMenu.emit(true);
  }

  /**
   * This toggles Collapse
   * @param {Boolean} collpase
   * @param {*} [$event]
   * @memberOf LmsTerminalBoundComponent
   */
  toggleCollpase(collpase: Boolean, $event?: any, singleClick?: boolean) {
    if ($event) {
      $event.stopPropagation();
    }
    if (this.collpase === null) {
      this.collpase = collpase;
    } else {
      this.collpase = null;
    }
    if (!singleClick) {
      singleClick = false;
    }
    // this.heightCalculate.emit(true);
    this.toggleBound.emit({ 'collpase': this.collpase, singleClick: singleClick, header: this.header });
  }

  /**
   * This method gets Pagging Data
   * @param {any} $event
   * @memberOf LmsTerminalBoundComponent
   */
  getPagingdata($event) {
    this.startPage = $event.paging.start ? $event.paging.start : '';
    this.endPage = $event.paging.end ? $event.paging.end : '';
  }

  /**
   * This method reset the collapse
   * @memberOf LmsTerminalBoundComponent
   */
  resetCollpase() {
    this.collpase = null;
    this.toggleBound.emit({ 'collpase': this.collpase, singleClick: false });
  }

  dropSVG(data) {

  }

  trackByTrainIdentifier(index, item) {
    // return item.trainIdentifier;
  }

  /**
   * get number of visible item by this method
   * @memberof LmsTerminalBoundComponent
   */
  getNumberofVisible() {
    this.endIndex = 0;
    this.boundTrainsPartial = [];
    if (this.boundTrains.length) {
      this.setPartialData();
      this.fillPartialData(this.endIndex);
      this.endIndex++;
      this.div.scrollTop = 0;
      this.viewPageDirective.updateScreenSizeSetting();
    }
  }

  /**
   * in starting wen we load new data then do all
   *  setting related to bound list view
   * @memberof LmsTerminalBoundComponent
   */
  loadData() {
    const locowidth = 165;
    const locoheight = 55;
    const trainWidth = 110;
    const scrollbarwidth = 21;
    const rowAccomodateCapacity = Math.ceil((this.viewPortWidth - trainWidth) / locowidth);
    const columnAccomodateCapacity = Math.ceil(this.viewPortHeight / locoheight) + 1;
    const scrollTop = this.div.scrollTop;
    const scrollHeight = this.div.scrollHeight;
    const viewportHeight = this.div.clientHeight;
    if ((scrollTop >= ((scrollHeight * 0.9) - (viewportHeight)))) {
      this.viewPageDirective.updateScreenSizeSetting();
      if (this.boundTrains.length !== this.boundTrainsPartial.length) {
        let rowsPerTrain = 0;
        let totalRows = 0;
        const startIndex = this.boundTrainsPartial ? this.boundTrainsPartial.length : 0;
        for (let i = startIndex; i < this.boundTrains.length; i++) {
          rowsPerTrain = Math.ceil(this.boundTrains[i].locoDetails.length / rowAccomodateCapacity);
          if (totalRows < columnAccomodateCapacity) {
            if (rowsPerTrain === 0) {
              totalRows += 1;
            } else {
              totalRows += rowsPerTrain;
            }
            this.endIndex++;
          } else if (totalRows >= columnAccomodateCapacity) {
            break;
          }
        }
        this.fillPartialData(this.endIndex);
      }
    }
  }
  /**
   * this methhos do partial section to viw bound list by
   *  this we not show full data in starting
   * @private
   * @memberof LmsTerminalBoundComponent
   */
  private setPartialData() {
    this.viewPortHeight = this.div.offsetHeight;
    this.viewPortWidth = this.div.offsetWidth;
    const locowidth = 165;
    const locoheight = 55;
    const trainWidth = 110;
    const scrollbarwidth = 21;
    const rowAccomodateCapacity = Math.ceil((this.viewPortWidth - trainWidth) / locowidth);
    const columnAccomodateCapacity = Math.ceil(this.viewPortHeight / locoheight) + 1;
    let rowsPerTrain = 0;
    let totalRows = 0;
    for (const train of this.boundTrains) {
      rowsPerTrain = Math.ceil(train.locoDetails.length / rowAccomodateCapacity);
      if (totalRows < columnAccomodateCapacity) {
        if (rowsPerTrain === 0) {
          totalRows += 1;
        } else {
          totalRows += rowsPerTrain;
        }
        this.endIndex++;
      } else if (totalRows >= columnAccomodateCapacity) {
        break;
      }
    }
  }

  /**
   * after knowing from where to where we need to show
   *  data then we fill data  by this method
   * @param {any} endIndex
   * @memberof LmsTerminalBoundComponent
   */
  fillPartialData(endIndex) {
    if (this.boundTrains.length) {
      const startIndex = this.boundTrainsPartial ? this.boundTrainsPartial.length : 0;
      for (let i = startIndex; i <= endIndex && i < this.boundTrains.length; i++) {
        this.boundTrainsPartial.push(this.boundTrains[i]);
      }
    }
  }


}

